// Shared constants for Editor and export functionality

const FONT_FAMILIES = {
  arial: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
  helvetica: 'Helvetica, "Helvetica Neue", Arial, sans-serif',
  georgia: 'Georgia, "Times New Roman", serif',
  timesNewRoman: '"Times New Roman", Times, serif',
  courierNew: '"Courier New", Courier, monospace',
  verdana: 'Verdana, Geneva, sans-serif',
  trebuchetMs: '"Trebuchet MS", Helvetica, sans-serif',
} as const;

export const FONT_FAMILY_MAP = {
  'Arial': FONT_FAMILIES.arial,
  'Helvetica': FONT_FAMILIES.helvetica,
  'Georgia': FONT_FAMILIES.georgia,
  'Times New Roman': FONT_FAMILIES.timesNewRoman,
  'Courier New': FONT_FAMILIES.courierNew,
  'Verdana': FONT_FAMILIES.verdana,
  'Trebuchet MS': FONT_FAMILIES.trebuchetMs
} as const;

export const FONT_FAMILY_EXPORT_MAP = {
  ARIAL: FONT_FAMILIES.arial,
  HELVETICA: FONT_FAMILIES.helvetica,
  GEORGIA: FONT_FAMILIES.georgia,
  TIMES_NEW_ROMAN: FONT_FAMILIES.timesNewRoman,
  COURIER_NEW: FONT_FAMILIES.courierNew,
  VERDANA: FONT_FAMILIES.verdana,
  TREBUCHET_MS: FONT_FAMILIES.trebuchetMs,
} as const;
